import * as React from "react";
import * as ReactDOM from "react-dom";
import { App } from "./app";
ReactDOM.render(React.createElement(App, null), document.getElementById("app"));
